<template>
  <div class="news" v-if="article && article.page && article.children">
    <div class="news-item" v-for="child in article.children" :key="child.id">
      <div class="img" v-if="getImg(child.transContent)">
        <img :src="getImg(child.transContent)">
      </div>
      <div class="news-data">
        <router-link
                :to="$i18nRoute({ name: 'article', params: { slug: child.slug } })"
                :key="child.id"
        >
          {{ child.transTitle }}
        </router-link>
        <div class="date">
          {{ new Date(child.publish_date) | dateFormat('DD.MM.YYYY') }}
        </div>
      </div>
    </div>
    <router-link
      :to="$i18nRoute({ name: 'blog', params: { slug: page.slug } })"
      :key="page.id"
    >
      {{ $t('Посмотреть все') }}
    </router-link>
  </div>
</template>

<script>
  import CMS from '@/model/cms'

  export default {
    props: {
      widget: Object,
      page: Object
    },
    data: () => ({
      article: []
    }),
    mounted () {
      CMS.loadBlogBySlug(this.page.slug, 3)
        .then((response) => {
          this.article = response.data
        })
        .catch((error) => {
          //@todo ошибки
        })
    },
    methods: {
      getImg (content) {
        let elContent = document.createElement('div')
        elContent.innerHTML = content.trim()

        let firstImage = elContent.getElementsByTagName('img')[0]

        if (firstImage) {
          return firstImage.src
        }

        return false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .news {
    a {
      color: inherit !important;
    }
  }
</style>
